import { WSButton } from "@wingspanhq/fe-component-library";
import { useHistory } from "react-router-dom";
import { PATH_WORK_LOGS_PAYER_TAB_TO_APPROVE } from "../../../../WorkLogs/paths";
import { NotificationTemplate } from "../index";

export type WorkLogSubmittedForReviewPayerContext = {
  payerName: string;
  payeeName: string;
  workLogNumber: string;
  actionUrl: string;
  reason?: string;
};

// Keeping the group threshold as 2 for now, can be adjusted later
const GROUP_THRESHOLD = 2;

export const WorkLogSubmittedForReviewPayer: NotificationTemplate<WorkLogSubmittedForReviewPayerContext> =
  {
    renderTitle: props =>
      props.group.length >= GROUP_THRESHOLD
        ? "Work logs awaiting review"
        : "Work log awaiting review",
    renderBody: props => {
      if (props.group.length >= GROUP_THRESHOLD) {
        return `${props.group.length} work logs are awaiting your review.`;
      }
      return `Work log #${props.context.workLogNumber} from ${props.context.payeeName} is awaiting your review.`;
    },
    Footer: props => {
      const history = useHistory();

      if (props.group.length >= GROUP_THRESHOLD) {
        return (
          <WSButton.Link
            size="S"
            rightIcon="chevron-right"
            onClick={() => {
              history.push(PATH_WORK_LOGS_PAYER_TAB_TO_APPROVE);
            }}
          >
            Review work logs
          </WSButton.Link>
        );
      }

      return (
        <WSButton.Link
          size="S"
          rightIcon="chevron-right"
          onClick={() => {
            history.push(props.context.actionUrl);
          }}
        >
          Review work log
        </WSButton.Link>
      );
    }
  };
